module.exports = __webpack_public_path__ + "assets/img/ranking.086ae612.png";